import { useState, useEffect, useCallback } from "react";

interface PromoModalOptions {
  enabled?: boolean;
  showOnFirstVisit?: boolean;
  showDelay?: number;
  buttonLink?: string;
}

export function usePromoModal(options: PromoModalOptions) {
  const [isOpen, setIsOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (!options.enabled) return;

    if (options.showOnFirstVisit) {
      const hasSeenModal = localStorage.getItem("promo_modal_seen") === "true";
      if (hasSeenModal) return;
    }

    const delay = options.showDelay ?? 1000;
    const timer = setTimeout(() => setIsOpen(true), delay);
    return () => clearTimeout(timer);
  }, [options.enabled, options.showOnFirstVisit, options.showDelay]);

  const handleClose = useCallback((): void => {
    setIsClosing(true);
    setTimeout(() => {
      setIsOpen(false);
      setIsClosing(false);
      if (options.showOnFirstVisit) {
        localStorage.setItem("promo_modal_seen", "true");
      }
    }, 300);
  }, [options.showOnFirstVisit]);

  const handleButtonClick = useCallback((): void => {
    if (options.buttonLink) {
      if (options.buttonLink.startsWith("#")) {
        window.location.href = options.buttonLink;
      } else {
        window.open(options.buttonLink, "_blank", "noopener,noreferrer");
      }
    }
    handleClose();
  }, [options.buttonLink, handleClose]);

  return { isOpen, isClosing, handleClose, handleButtonClick };
}
